
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor03 as ObiBipolar_transistor03Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-03.js';
 
 
 

 
 export const ObiBipolar_transistor03 = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-03',
   elementClass: ObiBipolar_transistor03Element,
   events: {
     
   }
  });
 
 